import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getFlatProfilePathname } from '../../../utils/link'
import { ProfileEntityWidgetItemContent } from '../ProfileEntityWidgetItemContent'

function ProfileFlatsWidgetItemContent({ value, ...restProps }) {
  const { handleClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  function handleClickTitle() {
    const link = getFlatProfilePathname({ availableSections, id: value })

    handleClick({
      link,
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  return (
    <ProfileEntityWidgetItemContent
      {...restProps}
      onClickTitle={handleClickTitle}
    />
  )
}

export default ProfileFlatsWidgetItemContent
